module.exports = __webpack_public_path__ + "media/entities/1030-c50ff71d.png";